import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import MachineryOwnerContent from './MachineryOwnerContent';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';

const form = {
  keyword: '',
};

function SettingsContainer({
  match,
  history,
  getMachineryOwnerList,
  machineryOwnerList,
  isLoading,
  removeMachineryOwner,
  machineryOwnerListPager,
  getSingleMachineryOwner,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Owner',
      modalSize: 'modal-lg',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Owner',
      modalSize: 'modal-lg',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this owner?',
      () => {
        removeMachineryOwner(data.id, () => {
          getMachineryOwnerList();
          const id = _.get(machineryOwnerList, '0.id');
          history.push(`${id}`);
          getSingleMachineryOwner(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getMachineryOwnerList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getMachineryOwnerList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:machineryOwnerId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Machinery Owners"
            getData={getMachineryOwnerList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:machineryOwnerId?`}
            listName="machineryOwner"
            label="Machinery Owners"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.full_name')}</div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.machineryOwnerId}
            data={machineryOwnerList}
            dataPager={machineryOwnerListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:machineryOwnerId?`}
                    render={() => (
                      <MachineryOwnerContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:machineryOwnerId?`}
                  render={() =>
                    !params.machineryOwnerId &&
                    machineryOwnerList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(machineryOwnerList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  machineryOwnerList: PropTypes.instanceOf(Array).isRequired,
  machineryOwnerListPager: PropTypes.instanceOf(Object).isRequired,
  removeMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleMachineryOwner: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  machineryOwnerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
  machineryOwnerListPager: _.get(api, `${c.GET_MACHINERY_OWNER}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_OWNER) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SettingsContainer);
